import { useState } from 'react'
import { Card } from '@/components/ui/card'
import { cn } from '@/lib/utils'
import { useWasteCategories } from '@/hooks/queries/useWasteCategories'
import { useWasteSubcategories } from '@/hooks/queries/useWasteSubcategories'
import { WasteCategoriesTab } from '@/pages/waste-types/components/WasteCategoriesTab'
import { WasteSubcategoriesTab } from '@/pages/waste-types/components/WasteSubcategoriesTab'
import { WasteTypesTab } from '@/pages/waste-types/components/WasteTypesTab'

type ActiveTab = 'categories' | 'subcategories' | 'types'

const TAB_LABELS: Record<ActiveTab, string> = {
  categories: 'Categorías',
  subcategories: 'Subcategorías',
  types: 'Tipos de material',
}

export function WasteTypesPage() {
  const [activeTab, setActiveTab] = useState<ActiveTab>('categories')

  const { data: categories = [] } = useWasteCategories()
  const { data: subcategories = [] } = useWasteSubcategories()

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-foreground">Residuos</h1>
      </div>

      <Card>
        {/* Tab bar */}
        <div className="flex border-b px-4">
          {(Object.keys(TAB_LABELS) as ActiveTab[]).map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={cn(
                'px-4 py-3 text-sm font-medium border-b-2 -mb-px transition-colors',
                activeTab === tab
                  ? 'border-primary text-foreground font-semibold'
                  : 'border-transparent text-muted-foreground hover:text-foreground'
              )}
            >
              {TAB_LABELS[tab]}
            </button>
          ))}
        </div>

        {activeTab === 'categories' && <WasteCategoriesTab />}
        {activeTab === 'subcategories' && <WasteSubcategoriesTab categories={categories} />}
        {activeTab === 'types' && <WasteTypesTab categories={categories} subcategories={subcategories} />}
      </Card>
    </div>
  )
}
